import { render, staticRenderFns } from "./TechInfo.vue?vue&type=template&id=4562cd81&scoped=true&"
import script from "./TechInfo.vue?vue&type=script&lang=js&"
export * from "./TechInfo.vue?vue&type=script&lang=js&"
import style0 from "./TechInfo.vue?vue&type=style&index=0&id=4562cd81&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562cd81",
  null
  
)

export default component.exports